var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.08 4.06575H23.844V1.59375H21.372V4.06575H9.01203V1.59375H6.54003V4.06575H5.30403C3.94443 4.06575 2.83203 5.17815 2.83203 6.53775V26.3138C2.83203 27.6734 3.94443 28.7858 5.30403 28.7858H25.08C26.4396 28.7858 27.552 27.6734 27.552 26.3138V6.53775C27.552 5.17815 26.4396 4.06575 25.08 4.06575ZM25.08 26.3138H5.30403V12.7178H25.08V26.3138ZM25.08 10.2458H5.30403V6.53775H25.08V10.2458Z",
    fill: "#8F8F8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.650269f5a1752f2f367276700424e6c5.svg";
export { ForwardRef as ReactComponent };